__turbopack_context__.v({
  "author": "styles-module__FqEfaa__author",
  "authorRow": "styles-module__FqEfaa__authorRow",
  "date": "styles-module__FqEfaa__date",
  "imgPlaceholder": "styles-module__FqEfaa__imgPlaceholder",
  "imgWrapper": "styles-module__FqEfaa__imgWrapper",
  "reviewContent": "styles-module__FqEfaa__reviewContent",
  "reviewRow": "styles-module__FqEfaa__reviewRow",
});
